import ArretTravailHistory from 'features/arretTravail/pages/history/history';
import React from 'react';

type Props = {};

const PageArretTravailHistory: React.FC<Props> = () => {
    return <ArretTravailHistory />;
};

export default PageArretTravailHistory;
